export default (theme) => {
  let { pixelsPerRem = 16 } = theme;
  let {
    minViewport = 320,
    maxViewport = 1280,
    decimals = 4,
  } = theme?.layout || {};
  const clampBuilder = (minFontSize, maxFontSize) => {
    if (minFontSize === maxFontSize) {
      return `${minFontSize}rem`;
    }
    const minWidth = minViewport / pixelsPerRem;
    const maxWidth = maxViewport / pixelsPerRem;

    const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth);
    const yAxisIntersection = -minWidth * slope + minFontSize;

    return `clamp(${minFontSize.toFixed(
      decimals,
    )}rem, ${yAxisIntersection.toFixed(decimals)}rem + ${(slope * 100).toFixed(
      decimals,
    )}vw, ${maxFontSize.toFixed(decimals)}rem)`;
  };
  return (value, fallback = null) => {
    if (value == null) {
      return fallback;
    }
    let min, max;
    if (Array.isArray(value)) {
      min = Number(value[0]) / 4;
      max = Number(value[1]) / 4;
    } else if (typeof value === "string") {
      let matches;
      if ((matches = value.match(/^(\d+|\d*\.\d+)-(\d+|\d*\.\d+)$/))) {
        min = Number(matches[1]) / 4;
        max = Number(matches[2]) / 4;
      }
    }
    if (min && max) {
      return clampBuilder(min, max);
    }
    if (typeof value === "number" || !isNaN(Number(value))) {
      return `${Number(value) / 4}rem`;
    }
    return value;
  };
};
